function throttle(fn, time, context) {
  let lock, args;

  function later () {
    // reset lock and call if queued
    lock = false;
    if (args) {
      wrapperFn.apply(context, args);
      args = false;
    }
  }

  function wrapperFn () {
    if (lock) {
      // called too soon, queue to call later
      args = arguments;

    } else {
      // lock until later then call
      lock = true;
      fn.apply(context, arguments);
      setTimeout(later, time);
    }
  }

  return wrapperFn;
}

module.exports = throttle;



//////////////////
// WEBPACK FOOTER
// ./~/@mapbox/mapbox-gl-draw/src/lib/throttle.js
// module id = 396
// module chunks = 2